import { useState, useEffect } from 'react';

const useAppLoader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const preloadAssets = async () => {
      const criticalImages = [
        // Profile image
        require('../assets/optimized/pfp.webp'),
        require('../assets/optimized/pfp.jpg'),
        // Company logos
        require('../assets/optimized/vortexio.webp'),
        require('../assets/optimized/DECGamingStudioLogo.webp'),
        require('../assets/optimized/ParulUniversityPost.webp'),
        require('../assets/optimized/bps.webp'),
      ];

      const projectVideos = [
        require('../assets/optimized/Zaikaflowad_compressed.mp4'),
        require('../assets/optimized/testflowai_compressed.mp4'),
        require('../assets/optimized/OfferWhisky_compressed.mp4'),
        require('../assets/blobTracking.mp4'),
      ];

      // Preload images
      const imagePromises = criticalImages.map((src) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(src);
          img.onerror = () => {
            console.warn(`Failed to preload image: ${src}`);
            resolve(src);
          };
          img.src = src;
        });
      });

      // Preload videos (just metadata to speed up later loading)
      const videoPromises = projectVideos.map((src) => {
        return new Promise((resolve) => {
          const video = document.createElement('video');
          video.preload = 'metadata';
          video.onloadedmetadata = () => resolve(src);
          video.onerror = () => {
            console.warn(`Failed to preload video: ${src}`);
            resolve(src);
          };
          video.src = src;
        });
      });

      try {
        // Wait for all assets to preload
        await Promise.all([...imagePromises, ...videoPromises]);
        
        // Minimum loading time for smooth UX
        await new Promise(resolve => setTimeout(resolve, 2000));
        
      } catch (error) {
        console.error('Error preloading assets:', error);
      }
    };

    preloadAssets();
  }, []);

  return { isLoading, setIsLoading };
};

export default useAppLoader;